module.exports = __webpack_public_path__ + "img/首页1.448c9a83.png";